module.exports = __webpack_public_path__ + "img/menu-icon-greeting.6ae7a2d7.png";